import { render, staticRenderFns } from "./PurchaseFish.vue?vue&type=template&id=1d55a62b&scoped=true"
import script from "./PurchaseFish.vue?vue&type=script&setup=true&lang=ts"
export * from "./PurchaseFish.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PurchaseFish.vue?vue&type=style&index=0&id=1d55a62b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d55a62b",
  null
  
)

export default component.exports